export default "<div class=\"shareBtn d-inline-block\" (click)=\"onClickLocal()\">\n  <img src=\"/assets/img/sharebtn@3x.png\" />\n</div>\n";